import React, { useEffect, useState, useCallback, useMemo, useRef } from "react"
import { AgGridReact } from "ag-grid-react"
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-material.css';
import Modal from "react-modal";
import downloadIcon from '../../assets/downloadIcon.png'
import ModalContent from '../../common/Modal/ModalContent';
import close_modal from '../../assets/ic_close_wh.svg'
import ic_filter from '../../assets/ic_filter.svg'
import { Button } from "../../common/Button/Button";
import ReactMultiSelectCheckboxes from "react-multiselect-checkboxes";
import { Info } from "react-feather";

const TotalResourceConsumedByUserTable = (props) => {
  const [openTotalResourceFilterModel, setTotalResourceFilterModal] = useState(false)

  const gridRef = useRef()
  const containerStyle = useMemo(() => ({ width: "100%", height: "100%" }), []);
  const gridStyle = useMemo(() => ({ height: "100%", width: "100%" }), []);

  const data = props.totalResourceConsumedByUser

  const [rowData, setRowData] = useState([]);
  const [filteredRowData, setFilteredRowData] = useState([]);
  const [isFilterOn, setIsFilterOn] = useState(false);

  // const footerRow = {
  //   resourcedisplay_name: "Total",
  //   // first_time_data: "Total" + " : " + " " + props.totalResourceConsumedByUser.reduce((total, row) => total + row.first_time_data, 0),
  //   resourcesConsumedAfter4April: "Total" + " : " + " " + isFilterOn ?  filteredRowData.reduce((total, row) => total + row.resourcesConsumedAfter4April, 0) : rowData.reduce((total, row) => total + row.resourcesConsumedAfter4April, 0),
  // };
  const footerRow = {
    resourcedisplay_name: "Total",
    resourcesConsumedAfter4April:
      "Total : " +
      (isFilterOn
        ? filteredRowData.reduce((total, row) => total + (row.resourcesConsumedAfter4April || 0), 0)
        : rowData.reduce((total, row) => total + (row.resourcesConsumedAfter4April || 0), 0))
  };


  // my useEffect
  useEffect(() => {
    const formatUserResourceRows = (backendData) => {
      const rows = [];

      backendData.forEach(user => {
        // Main row for user
        rows.push({
          isUserRow: true,
          userPhone: user.userPhone,
          // resourcesConsumedBefore4April: user.resourcesConsumedBefore4April,
          resourcesConsumedAfter4April: user.resourcesConsumed
        });

        // Rows for each resource
        user.resources.forEach(resource => {
          rows.push({
            isUserRow: false,
            resourceName: resource.sResourceDisplayName,
            resourceDate: resource.dtCreated,
            userPhone: "", // Leave blank to avoid confusion
            resourcesConsumedBefore4April: "",
          });

        });
      });

      return rows;
    };

    const formatted = formatUserResourceRows(data);
    console.log(formatted, ">>>>>formatted");

    setRowData(formatted)
  }, [data])

  // my handleFilter
  const [filterVal, setFilterVal] = useState("")
  // const handleFilterByMobileNumber = () => {
  //   if (filterVal) {
  //     let filteredData = rowData.filter((row) => row.userPhone == filterVal)

  //     setRowData(filteredData);
  //     setTotalResourceFilterModal(false);
  //   } else {
  //     setRowData(props.totalResourceConsumedByUser);
  //   }
  // }

  const handleFilterByMobileNumber = () => {
    if (filterVal) {
      setIsFilterOn(true);

      let filteredData = data.filter((row) => row.userPhone == filterVal);
      console.log(filteredData, ">>>>filteredData");


      const formatUserResourceRows = (backendData) => {
        const rows = [];

        backendData.forEach(user => {
          // Main row for user
          rows.push({
            isUserRow: true,
            userPhone: user.userPhone,
            // resourcesConsumedBefore4April: user.resourcesConsumedBefore4April,
            resourcesConsumedAfter4April: user.resourcesConsumed
          });

          // Rows for each resource
          user.resources.forEach(resource => {
            rows.push({
              isUserRow: false,
              resourceName: resource.sResourceDisplayName,
              resourceDate: resource.dtCreated,
              userPhone: "", // Leave blank to avoid confusion
              resourcesConsumedBefore4April: "",
            });

          });
        });

        return rows;
      };

      const formatted = formatUserResourceRows(filteredData);
      console.log(formatted, ">>>Formatted filter");


      setFilteredRowData(formatted);
      setTotalResourceFilterModal(false);
    } else {
      setIsFilterOn(false);
      setTotalResourceFilterModal(false);
    }
  }

  const handleClearClick = () => {
    setFilterVal("")
  }

  //////////////////////////////////////////////

  const openTotalResourceModalisTrue = () => {
    setTotalResourceFilterModal(true)
  }

  const openTotalResourceModalisFalse = () => {
    setTotalResourceFilterModal(false)
  }


  const CustomCellRenderer = (props) => {
    let resourceName = props.value;
    if (resourceName === null) {
      resourceName = "Not Provided";
    }
    if (resourceName === "Total") {
      return <div style={{ textAlign: "right", display: "none" }}>{resourceName}</div>;
    } else {
      return <div>{resourceName}</div>;
    }
  };

  // const [columnDefs] = useState([
  //   {
  //     field: "userPhone",
  //   headerName: "Mobile Number",
  //     headerComponentFramework: (params) => {
  //       return (
  //         <div style={{ display: "flex", width: '50px', alignItems: "center" }}>
  //           <div style={{ marginRight: "110px" }}>{params.displayName}</div>
  //           <img
  //               alt=""
  //               src={ic_filter}
  //               height={"25px"}
  //               width={"25px"}
  //               className="conv-mr10"
  //               onClick={() => openTotalResourceModalisTrue()}
  //           />
  //         </div>
  //       );
  //     },
  //     width: 380,
  //     cellStyle: { 'white-space': 'normal' },
  //     autoHeight: true,
  //     cellRendererFramework: CustomCellRenderer,
  //   },
  //   {
  //     field: "resourcesConsumed",
  //     headerName: "Total Resource Consumed",
  //     flex: 1,
  //     headerComponentFramework: (params) => {
  //       return (
  //         // <div style={{ display: "flex", width: '50px', alignItems: "center" }}>
  //         //   <div style={{ marginRight: "210px" }}>{params.displayName}</div>
  //         // </div>

  //         <div style={{ display: "flex", justifyContent: 'flex-end', width: '100%', alignItems: "center" }}>
  //           <div>
  //             {params.displayName}
  //           </div>
  //         </div>
  //       );
  //     },
  //     width: 380,
  //     cellStyle: { textAlign: "right" },
  //     autoHeight: true,
  //     cellRendererFramework: CustomCellRenderer,
  //   },
  // ]);

  const [columnDefs, setColumnDefs] = useState([
    // {
    //   field: "userPhone",
    //   headerName: "User Phone / Resource",
    //   width: 580,
    //   cellStyle: params => {
    //     return params.data.isUserRow
    //       ? { 'white-space': 'normal', fontWeight: 'bold' }
    //       : { fontStyle: 'italic', color: '#555' };
    //   },
    //   autoHeight: true,
    //   cellRendererFramework: CustomCellRenderer,
    //   headerComponentFramework: (params) => (
    //     <div style={{ display: "flex", width: '50px', alignItems: "center" }}>
    //       <div style={{ marginRight: "110px" }}>{params.displayName}</div>
    //       <img
    //         alt=""
    //         src={ic_filter}
    //         height={"25px"}
    //         width={"25px"}
    //         className="conv-mr10"
    //         onClick={() => openTotalResourceModalisTrue()}
    //       />
    //     </div>
    //   )
    // },
    {
      field: "userPhone",
      headerName: "User Phone / Resource",
      width: 680,
      autoHeight: true,
      cellRendererFramework: (params) => {
        if (params.data.isUserRow) {
          return <span style={{ fontWeight: "bold" }}>{params.value}</span>;
        } else {
          return (
            <span style={{ fontStyle: "italic", color: "#000" }}>
              {params.data.resourceName}{" "}
              <span style={{ color: "#75287C" }}>({params.data.resourceDate})</span>
            </span>
          );
        }
      },
      cellStyle: { 'white-space': 'normal' },
      headerComponentFramework: (params) => (
        <div style={{ display: "flex", width: '50px', alignItems: "center" }}>
          <div style={{ marginRight: "110px" }}>{params.displayName}</div>
          <img
            alt=""
            src={ic_filter}
            height={"25px"}
            width={"25px"}
            className="conv-mr10"
            onClick={() => openTotalResourceModalisTrue()}
          />
        </div>
      )
    },
    // {
    //   field: "resourcesConsumedBefore4April",
    //   headerName: "Resource Consumed before 4th April",
    //   flex: 1,
    //   // width: 380,
    //   cellStyle: params => ({
    //     textAlign: "right",
    //     fontWeight: params.data.isUserRow ? 'bold' : 'normal'
    //   }),
    //   autoHeight: true,
    //   cellRendererFramework: CustomCellRenderer,
    //   headerComponentFramework: (params) => (
    //     <div style={{ display: "flex", justifyContent: 'flex-end', width: '100%', alignItems: "center" }}>
    //       <div>{params.displayName}</div>
    //     </div>
    //   )
    // },
    {
      field: "resourcesConsumedAfter4April",
      headerName: "Resource Consumed after 4th April",
      flex: 1,
      // width: 380,
      cellStyle: params => ({
        textAlign: "right",
        fontWeight: params.data.isUserRow ? 'bold' : 'normal'
      }),
      autoHeight: true,
      cellRendererFramework: CustomCellRenderer,
      headerComponentFramework: (params) => (
        <div style={{ display: "flex", justifyContent: 'flex-end', width: '100%', alignItems: "center" }}>
          <div>{params.displayName}</div>
        </div>
      )
    }
  ]);


  const gridOptions = useMemo(() => ({
    suppressScrollOnNewData: true,
  }), []);

  const overlayNoRowsTemplate = rowData.length === 1 && rowData[0].sEntryPoint === "No Data Available"
    ? '<span class="ag-overlay-no-rows-center">No data available</span>'
    : '<span class="ag-overlay-no-rows-center">loading...</span>';

  console.log(filterVal, ">>>>filterVal in table-2");

  return (
    <div>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        // justifyContent: 'center',
        margin: 10
      }}>
        <h3 className="spled-colored-label" style={{
          fontSize: "20px",
          textAlign: 'center',
          marginRight: 10
        }}>3. Total Resource Consumed By User after 4th April</h3>
        <span style={{ cursor: "pointer" }} title="Display of resources consumed by user after 4th April">
          <Info style={{ width: "15px", marginRight: "10px", marginBottom: "5px" }} />
        </span>
      </div>
      <div style={{
        height: "50vh",
      }}>
        <div style={{ height: "100%", boxSizing: "border-box" }}>
          <div style={gridStyle} className="ag-theme-material">
            <AgGridReact ref={gridRef}
              rowData={isFilterOn ? filteredRowData : rowData}
              // rowData={data}
              columnDefs={columnDefs}
              pinnedBottomRowData={[footerRow]}
              gridOptions={gridOptions}
              overlayNoRowsTemplate={
                '<span class="ag-overlay-loading-center">No data available...</span>'
              }
              rowClassRules={{
                'total-row': 'data.resourcedisplay_name === "Total"'
              }}
            >
            </AgGridReact>
          </div>
        </div>

        <Modal isOpen={openTotalResourceFilterModel}>
          <ModalContent className="EngagedDashboard-filter-modal">
            <div className="modal-header">
              <span className="modal-title">Filter</span>
              <img
                alt="close"
                id="Close"
                src={close_modal}
                className="close modal-close"
                onClick={openTotalResourceModalisFalse}
              />
            </div>

            <div className="modal-body">
              <br />
              <div className="row">
                <div className="col-12 spled-container">
                  <div className="width-100">
                    <input placeholder="Mobile Number" type="number" style={{ width: "100%", height: "35px", padding: "0px 10px" }} value={filterVal} onChange={(e) => setFilterVal(e.target.value)} />
                  </div>
                </div>
              </div>
              <br />
              <div className='row d-flex justify-content-center align-items-center'>
                <div className="offset-1 col-5">
                  <Button className="esp-inline-button"
                    onClick={handleFilterByMobileNumber}
                  >Search</Button>
                </div>
                <div className="col-5">
                  <Button className="esp-inline-button" onClick={handleClearClick}>Clear</Button>
                </div>
              </div>

            </div>
          </ModalContent>
        </Modal>
      </div>
    </div>
  )
}

export default TotalResourceConsumedByUserTable
